import { render, staticRenderFns } from "./NavDrawer.vue?vue&type=template&id=bca3b3bc&scoped=true&"
import script from "./NavDrawer.vue?vue&type=script&lang=ts&"
export * from "./NavDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./NavDrawer.vue?vue&type=style&index=0&id=bca3b3bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca3b3bc",
  null
  
)

export default component.exports